export const HEADER_HEIGHT = 60;

export const TESTIMONIAL_TYPE = {
  owner: 'owner'
};